import { useCallback, useEffect, useState } from 'react';

/**
 * Light reading (BRAND_SPEC §5.2): a cream "Day" ground for long reading,
 * chosen in the menu and kept per browser under apr-theme ("day" | "night").
 * index.html applies a saved choice before first paint; this keeps it in step.
 */
const KEY = 'apr-theme';
const COLORS = { day: '#F6F1E8', night: '#000000' };

function readTheme() {
  try {
    return localStorage.getItem(KEY) === 'day' ? 'day' : 'night';
  } catch (e) {
    return 'night';
  }
}

function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === 'day') root.setAttribute('data-theme', 'day');
  else root.removeAttribute('data-theme');
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute('content', COLORS[theme]);
}

export function useLightReading() {
  const [theme, setTheme] = useState(readTheme);

  useEffect(() => { applyTheme(theme); }, [theme]);

  const toggle = useCallback(() => {
    setTheme((prev) => {
      const next = prev === 'day' ? 'night' : 'day';
      try { localStorage.setItem(KEY, next); } catch (e) { /* storage blocked: this visit only */ }
      return next;
    });
  }, []);

  return { lightReading: theme === 'day', toggleLightReading: toggle };
}
